import { React, useState } from 'react';
import {
  AdjustmentsHorizontalIcon,
  ArrowsUpDownIcon
} from '@heroicons/react/20/solid';
import VenueList from '../../Components/Venue/List';
import { ReactSVG } from 'react-svg';
import { capitalize } from '../../Utils';


const LearnMore = () => {


  const [kelebihan] = useState([
    {
      image: "/img-why-fityuk-1.svg",
      title: "Reservasi Lapang Mudah",
      description: "Anda tak perlu menginstall aplikasi, cukup menggunakan browser lalu mengisi nama, nomor telepon, dan email. Anda sudah dapat melakukan reservasi lapang."
    },
    {
      image: "/img-why-fityuk-2.svg",
      title: "Berbagai Macam Pilihan Jenis Olahraga",
      description: "Berbagai olahraga populer yang banyak digemari saat ini seperti sepakbola, mini soccer, futsal, badminton, tennis, padel)"
    },
    {
      image: "/img-why-fityuk-3.svg",
      title: "Berbagai Macam Pilihan Metode Pembayaran",
      description: "Fityuk menyediakan Virtual Account dari bank-bank umum, serta E-Money untuk membayar reservasi lapang anda."
    },
    {
      image: "/img-why-fityuk-4.svg",
      title: "Layanan Support",
      description: "Jika reservasi lapang anda mengalami kendala, silahkan hubungi Customer Service kami segera."
    }
  ]);

  return (
    <div className='flex flex-col'>
    <div className='flex justify-center items-center bg-[#d43a3a]/80 rounded-full mx-auto px-6 py-4 lg:px-10 lg:py-4'>
      <span className='text-center text-white font-bold text-[18px] lg:text-[22px]'>
        Temukan Tempat Favoritmu untuk berolahraga
      </span>
    </div>

      <div className="flex flex-col rounded-2xl bg-[#fff] p-8 mt-8 lg:p-12 items-center justify-center">
        <span className="text-[26px] font-extrabold">
          Kenapa bergabung sebagai Vendor Fityuk
        </span>

        <div className="flex mt-16 flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0">

          <div className='flex flex-1'>
            <img
              className="object-contain items-end"
              src="/learn-more/dashboard-fityuk.webp"
              alt="FitYuk Dashboard"
            />
          </div>

          <div className="flex flex-col flex-1">
            <span className="text-[22px] font-extrabold text-[#e19b9b]">
              01
            </span>
            <span className="text-[22px] font-extrabold">
              Admin Dashboard
            </span>
            <span className="mt-4 text-[14px]">
              Anda akan mendapatkan Dashboard untuk memantau berbagai insight seperti lapang terlaris, paket terlaris, user terbaik, sesi booking terlaris, dan lain-lain.
            </span>
          </div>

        </div>

        <div className="flex mt-16 flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0">

          <div className='flex flex-1'>
            <img
              className="object-contain items-end"
              src="/learn-more/addon-fityuk.webp"
              alt="FitYuk Dashboard"
            />
          </div>

          <div className="flex flex-col flex-1">
            <span className="text-[22px] font-extrabold text-[#e19b9b]">
              02
            </span>
            <span className="text-[22px] font-extrabold">
              Menambahkan Add-On
            </span>
            <span className="mt-4 text-[14px]">
              Anda dapat menambahkan Add On untuk penyewa lapang seperti air minum, jersey, makanan, piala / medali, dan lainnya sesuai kebutuhan
            </span>
          </div>

        </div>

        <div className="flex mt-16 flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0">

          <div className='flex flex-1'>
            <img
              className="object-contain items-end"
              src="/learn-more/pencairan-fityuk.webp"
              alt="FitYuk Dashboard"
            />
          </div>

          <div className="flex flex-col flex-1">
            <span className="text-[22px] font-extrabold text-[#e19b9b]">
              03
            </span>
            <span className="text-[22px] font-extrabold">
              Pencairan Dana Cepat
            </span>
            <span className="mt-4 text-[14px]">
              Proses pengajuan pencairan dana cepat oleh tim admin kami maksimal 1x24 jam, langsung ditransferkan ke rekening anda.
            </span>
          </div>

        </div>

        <div className="flex mt-16 flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0">

          <div className='flex flex-1'>
            <img
              className="object-contain items-end"
              src="/learn-more/kelolajadwal-fityuk.webp"
              alt="FitYuk Dashboard"
            />
          </div>
          <div className="flex flex-col flex-1">
            <span className="text-[22px] font-extrabold text-[#e19b9b]">
              04
            </span>
            <span className="text-[22px] font-extrabold">
              Mudah Mengelola Jadwal
            </span>
            <span className="mt-4 text-[14px]">
              Admin anda akan mendapatkan akses full dalam mengelola & memantau jadwal di tiap lapang yang anda miliki
            </span>
          </div>

        </div>

        <div className="flex mt-16 flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0">

          <div className='flex flex-1'>
            <img
              className="object-contain items-end"
              src="/learn-more/paket-fityuk.webp"
              alt="FitYuk Dashboard"
            /></div>

          <div className="flex flex-col flex-1">
            <span className="text-[22px] font-extrabold text-[#e19b9b]">
              05
            </span>
            <span className="text-[22px] font-extrabold">
              Menambahkan Jasa Fotografi,
              Videografi & Wasit
            </span>
            <span className="mt-4 text-[14px]">
              Anda dapat membuat paket menarik untuk penyewa lapang dengan menambahkan jasa fotografi, videografi, atau jika anda membuat kompetisi dapat juga ditambahkan jasa wasit.
            </span>
          </div>

        </div>

        <div className="flex mt-16 flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0 relative" >

          <div className='flex flex-1'>
            <img
              className="object-contain items-end"
              src="/learn-more/kolase-gabung-fityuk.webp"
              alt="FitYuk Dashboard"
            /></div>

          <div className="flex flex-col flex-1 p-8 justify-center bg-[#fff5f5] rounded-2xl relative absolute">
            <img src='/learn-more/logo-half-bg.svg' className='absolute w-[162px] right-0' />
            <span className="text-[22px] font-bold">Ayo bergabung dan menjadi
              bagian Fityuk, Tingkatkan
              pendapatan lapangan anda!
            </span>
            <button onClick={() => { 
              window.location.href = 'https://admin.fityuk.com/registration';
            }} className='w-fit mt-[16px] bg-primaryRed text-white rounded-lg pl-4 pr-4 py-2 text-[12px] font-semibold flex items-center space-x-1'>
              <img src='/ic-pen.svg' alt="Pen icon" className='h-[20px]' />
              <span>Isi Formulir Bergabung</span>
            </button>
          </div>


        </div>

        
      </div>
    </div>
  )
}

export default LearnMore;